<footer>
    <div class="inner text-center">
        <a href="https://www.autoconfig.cloud/home"><img src="./../../../assets/images/f_logo.png" /> </a>
        <div>
            <ul class="c-footer-nav">
                <li>
                    <a href="https://www.autoconfig.cloud/home">Home</a>
                </li>
                <li>
                    <a href="https://www.autoconfig.cloud/services">Services</a>
                </li>
                <li>
                    <a href="https://www.autoconfig.cloud/solution">Solutions</a>
                </li>
                <li>
                    <a href="https://www.autoconfig.cloud/contactus">Contact Us</a>
                </li>
            </ul>
        </div>
        <p class="copy-footer-font">© Copyright 2021 AutoConfig.Cloud. ALL RIGHT RESERVED <span>|</span> <a href="#" class="privacy-link"> Privacy Policy</a></p>
    </div>
</footer>